export const CANCEL_BUTTON_TEXT = "Cancel";
export const LOGOUT_CONFIRM_MESSAGE = "Are you sure you want to \nLogout?";

export default {
  CANCEL_BUTTON_TEXT,
  LOGOUT_CONFIRM_MESSAGE,
};
